import { useQuery } from 'react-query';
import {
	getBios,
	getCancerStages,
	getCancerSubtypes,
	getCancerTypes
} from '../../api/studiesAPI';
import Loader from '../ui/Loader';
import { Icon } from '@mui/material';
import './CancerDetailsForm.scss';

const CancerDetailsForm = ({
	tableRow,
	onTableRowChange,
	index,
	sendProtocolInfoHandler,
	onDeleteRow
}) => {
	const { isLoading, isError, error, data } = useQuery({
		queryKey: ['cancer-types'],
		queryFn: getCancerTypes,
		retry: false,
		staleTime: 3000000 //5 minutes to refetch
	});

	const {
		isLoading: isLoading2,
		isError: isError2,
		data: subtypes
	} = useQuery({
		queryKey: ['cancer-subtypes', tableRow.cancerType],
		queryFn: () => getCancerSubtypes(tableRow.cancerType),
		retry: false,
		staleTime: 3000000, //5 minutes to refetch
		enabled: !!tableRow.cancerType
	});

	const {
		isLoading: isLoading3,
		isError: isError3,
		data: stages
	} = useQuery({
		queryKey: [
			'stages',
			tableRow.cancerType,
			tableRow.cancerSubtypes
		],
		queryFn: () =>
			getCancerStages(
				tableRow.cancerType,
				tableRow.cancerSubtypes
			),
		retry: false,
		staleTime: 3000000, //5 minutes to refetch
		enabled: !!tableRow.cancerSubtypes
	});

	const {
		isLoading: isLoading4,
		isError: isError4,
		data: bios
	} = useQuery({
		queryKey: [
			'bios',
			tableRow.cancerType,
			tableRow.cancerSubtypes,
			tableRow.cancerStages
		],
		queryFn: () =>
			getBios(
				tableRow.cancerType,
				tableRow.cancerSubtypes,
				tableRow.cancerStages
			),
		retry: false,
		staleTime: 3000000, //5 minutes to refetch
		enabled: !!tableRow.cancerStages
	});

	if (isLoading) {
		return <Loader />;
	}

	if (isLoading2) {
		return <Loader />;
	}

	if (isLoading3) {
		return <Loader />;
	}

	if (isLoading4) {
		return <Loader />;
	}
	const { cancerTypes } = data.data;

	const availableSubtype = subtypes
		? subtypes.data.subtypes
		: [];

	const availableStages = stages ? stages.data.stages : [];

	const availableBios = bios ? bios.data.bios : [];

	const cancerTypeHandler = (e) => {
		onTableRowChange(
			{
				cancerType: e.target.value,
				cancerSubtypes: tableRow.cancerSubtypes,
				cancerStages: tableRow.cancerStages,
				biomarkers: tableRow.biomarkers
			},
			index
		);
	};

	const cancerSubtypeHandler = (e) => {
		onTableRowChange(
			{
				cancerType: tableRow.cancerType,
				cancerSubtypes: e.target.value,
				cancerStages: tableRow.cancerStages,
				biomarkers: tableRow.biomarkers
			},
			index
		);
	};

	const stagesHandler = (e) => {
		onTableRowChange(
			{
				cancerType: tableRow.cancerType,
				cancerSubtypes: tableRow.cancerSubtypes,
				cancerStages: e.target.value,
				biomarkers: tableRow.biomarkers
			},
			index
		);
	};

	const biomarkerHandler = (e) => {
		onTableRowChange(
			{
				cancerType: tableRow.cancerType,
				cancerSubtypes: tableRow.cancerSubtypes,
				cancerStages: tableRow.cancerStages,
				biomarkers: e.target.value
			},
			index
		);
	};

	const delteRowFunction = () => {
		onDeleteRow(index);
	};

	return (
		<tr>
			<td>
				<select
					name='cancer-types'
					id='cancerTypes'
					onChange={cancerTypeHandler}
					className='form-control cancer-select'
					defaultValue={tableRow.cancerType}
				>
					<option value=''>Enter Cancer Type</option>
					{cancerTypes.map((type, i) => {
						return (
							<option key={i} value={type.db}>
								{type.type}
							</option>
						);
					})}
				</select>
				{isError && (
					<p className='error-text'>
						We had an error loading the information, please
						try again.
					</p>
				)}
			</td>
			<td>
				<select
					name='cancer-subtypes'
					id='cancerSubtypes'
					className='form-control'
					onChange={cancerSubtypeHandler}
					defaultValue={tableRow.cancerSubtypes}
				>
					<option value=''>Enter Cancer Subtype</option>
					{availableSubtype?.map((subtype, i) => {
						return (
							<option key={i} value={subtype}>
								{subtype.replaceAll('_', ' ')}
							</option>
						);
					})}
				</select>
			</td>
			<td>
				<select
					name='cancer-stages'
					id='cancerStages'
					className='form-control'
					onChange={stagesHandler}
					defaultValue={tableRow.cancerStages}
				>
					<option value=''>Enter Stage</option>
					{availableStages?.map((stage, i) => {
						return (
							<option key={i} value={stage}>
								{stage.replaceAll('_', ' ')}
							</option>
						);
					})}
				</select>
			</td>
			<td>
				<select
					name='cancer-biomarkers'
					id='cancerBiomarkers'
					className='form-control'
					onChange={biomarkerHandler}
					defaultValue={tableRow.biomarkers}
				>
					<option value=''>Enter Bios</option>
					{availableBios?.map((biomarker, i) => {
						return (
							<option key={i} value={biomarker}>
								{biomarker.replaceAll('_', ' ')}
							</option>
						);
					})}
				</select>
			</td>
			<td>
				<Icon
					className='row-dele-icon'
					onClick={delteRowFunction}
				>
					delete
				</Icon>
			</td>
		</tr>
	);
};

export default CancerDetailsForm;
